module.exports = __webpack_public_path__ + "img/wallpaper_four.f9b16b7a.png";